var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"footer-content"},[_c('span',[_vm._v("© 1998-2021 AirTreks. All rights reserved.")]),(!_vm.affiliateId)?_c('span',[_vm._v("Support: 1 (503) 528-1005")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }